import * as React from 'react';

export const ArrowIcon = props => (
    <svg width={10} height={18} {...props}>
        <path
            d="M9.56.05A.76.76,0,0,0,8.78.2L.21,8.51a.68.68,0,0,0,0,1L8.78,17.8a.74.74,0,0,0,.51.2A.86.86,0,0,0,9.56,18a.69.69,0,0,0,.44-.64V.69A.69.69,0,0,0,9.56.05Z" />
    </svg>
);
